<template>
  <div>
    <h3>さぁ、あなたの『読んだ！』</h3>
    <h4>を、ここに！</h4>
    <br>
    <br>
    <p class="moji">『読んだ！』というあなたの爽快感と達成感を記録していくアプリです！</p>
    <br>
    <br>
    <p class="moji">あなたの『読んだ！』を貯めて他の人と共有していきましょう！</p>
    <br>
    <br>
    <h5>さっそく、
      <span>
        <router-link v-if="!isSignedIn" to="/signin">読んだ本を記録する</router-link>
        <router-link v-else to="/about">読んだ本を記録する</router-link>
      </span>
    </h5>
  </div>
</template>

<script>
export default {
  computed: {
    isSignedIn() {
      return this.$store.getters.isSignedIn
    }
  },
}
</script>

<style scoped>
.moji{
  width: 80%;
  margin: auto;
}
</style>